import { z } from 'zod';

import { makeEndpoint } from '../common';
import { TranslationSchema } from '../translation';

export const PatchTranslationsForCategoriesRequestSchema = z.object({
  translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
});

export const PatchTranslationsForCategoriesEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId }: { brandId: string }) => `/v1/brands/${brandId}/categories/i18n`,
  responseSchema: z.void(),
  requestSchema: PatchTranslationsForCategoriesRequestSchema,
});
